module.exports = __webpack_public_path__ + "static/media/center-middle.5a6b0d02.png";